import * as Rollbar from 'rollbar'; // When using Typescript < 3.6.0.
// `import Rollbar from 'rollbar';` is the required syntax for Typescript 3.6.x.
// However, it will only work when setting either `allowSyntheticDefaultImports`
// or `esModuleInterop` in your Typescript options.
import {
  Injectable,
  Inject,
  InjectionToken,
  ErrorHandler
} from '@angular/core';

import { environment } from '../../../environments/environment';
import { UserService } from '../../shared/services/user.service';
import { catchError, of } from 'rxjs';

const rollbarConfig = <Rollbar.Configuration>{
  accessToken: '37e0aae1843342ebba62ab85609baa22',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      source_map_enabled: true,

      code_version: '{{ROLLBAR_CODE_VERSION}}',
    },
    
  },
  logLevel: 'error',
  checkIgnore: function (isUncaught: boolean, args: Rollbar.LogArgument[], payload: Rollbar.Configuration) {
    return payload.environment == 'Development';
  }
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar, private userService: UserService) {
    userService.getUserInfo()
      .pipe(
        catchError(() => of(null))
      )
      .subscribe((userInfo) => {
        if (!userInfo) {
          return;
        }

        this.rollbar.configure({
          payload: {
            person: {
              id: userInfo.id,
              username: userInfo.userName,
              email: userInfo.email
            }
          }
        });
      })
    ;
  }

  handleError(err: any): void {
    this.rollbar.error(err.originalError || err);

    throw err;
  }
}

export function rollbarFactory() {
  rollbarConfig.payload.environment = environment.rollbarEnvironment;

  return new Rollbar(rollbarConfig);
}
